/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Condition } from './Condition';
import {
  ConditionFromJSON,
  ConditionFromJSONTyped,
  ConditionToJSON,
} from './Condition';
import type { RuleSettings } from './RuleSettings';
import {
  RuleSettingsFromJSON,
  RuleSettingsFromJSONTyped,
  RuleSettingsToJSON,
} from './RuleSettings';

/**
 *
 * @export
 * @interface RulePatch
 */
export interface RulePatch {
  /**
   * Rule conditions
   * @type {Array<Condition>}
   * @memberof RulePatch
   */
  conditions?: Array<Condition>;
  /**
   * Rule settings in dict
   * @type {RuleSettings}
   * @memberof RulePatch
   */
  settings?: RuleSettings;
  /**
   * Rule Type
   * @type {string}
   * @memberof RulePatch
   */
  type: RulePatchTypeEnum;
}

/**
 * @export
 */
export const RulePatchTypeEnum = {
  Call: 'call',
  Sms: 'sms',
} as const;
export type RulePatchTypeEnum =
  (typeof RulePatchTypeEnum)[keyof typeof RulePatchTypeEnum];

/**
 * Check if a given object implements the RulePatch interface.
 */
export function instanceOfRulePatch(value: object): value is RulePatch {
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function RulePatchFromJSON(json: any): RulePatch {
  return RulePatchFromJSONTyped(json, false);
}

export function RulePatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RulePatch {
  if (json == null) {
    return json;
  }
  return {
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionFromJSON),
    settings:
      json['settings'] == null
        ? undefined
        : RuleSettingsFromJSON(json['settings']),
    type: json['type'],
  };
}

export function RulePatchToJSON(value?: RulePatch | null): any {
  if (value == null) {
    return value;
  }
  return {
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionToJSON),
    settings: RuleSettingsToJSON(value['settings']),
    type: value['type'],
  };
}
